module.exports = __webpack_public_path__ + "img/43.10.pH.19e0efa3.png";